import React, {Component} from 'react';
import {connect} from 'react-redux';
import { bindActionCreators } from 'redux';

import AnimalTypeSwitcher from './../../components/AnimalTypeSwitcher/AnimalTypeSwitcher';
import * as actionTypes from './../../store/actions/animalTypeAction';
import fetchAnimalTypeAction from './../../store/actions/fetch/fetchAnimalTypeAction';
import Loader from './../../components/Loader/Loader'

/**
 * Animal Type container
 */
class AnimalType extends Component {
  componentDidMount() {
    const {fetchData} = this.props;
    fetchData();
  }

  render() {
    const {data, error, pending, selected, onSelect, defaultValues, ready} = this.props;

    // If there is a need for default data
    if(!ready && !error && !pending) {
      defaultValues();
    }
    // If Animal type data is pending
    if(pending || !ready) return (
      <Loader/>
    );
    // Return switcher
    return (
      <div className='nppe2-fc-animal-type-switcher__wrapper'>
        {error && <span className='nppe2-fc-animal-type-switcher__error'>{error}</span>}
        {!error && <AnimalTypeSwitcher data={data} selected={selected} clicked={onSelect}/>}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    selected: state.animalTypeReducer.selected,
    error: state.animalTypeReducer.error,
    data: state.animalTypeReducer.data,
    pending: state.animalTypeReducer.pending,
    ready: state.animalTypeReducer.ready,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    ...bindActionCreators({
      fetchData: fetchAnimalTypeAction
    }, dispatch),
    onSelect: (id, animalType) => dispatch({
      type: actionTypes.SELECT,
      selected: id,
      animalType: animalType,
    }),
    defaultValues: () => dispatch({
      type: actionTypes.DEFAULT,
    }),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(AnimalType);
